export default __webpack_public_path__ + "static/media/play-game-button.f179c516.png";